import client from './api-client';

export const getConfiguracionForm10 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form10: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getDatoPagoRecepcionado = async(query) => {
    try {
        
        const response = await client.get(`caso/recobro/pago-recepcionado?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                pagoRecepcionado: response.data.object,
               
                query: query
            };
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getMonedas= async(query) => {
    try {
        
        const response = await client.getSelect(`monedas?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                monedas: response.data.object,
               
                query: query
            };
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getPersona= async(query) => {
    try {
        
        const response = await client.get(`persona?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                persona: response.data.object,
               
                query: query
            };
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const enviarLegalizacionPago = async(file) => {
    try {
        
        const response = await client.post('caso/recobro/legalizar', file);
        
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaPostLegaliza : response.data
                    };
        } else {
            return {respuestaPostLegaliza : response.data};
        }

    } catch(error){
        throw error;
    }
}